/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Pagination } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
var TablePagination = function TablePagination(props) {
  var currentPage = props.currentPage,
    lastPage = props.lastPage,
    onPageChange = props.onPageChange,
    color = props.color;
  var handlePageChange = function handlePageChange(event, _ref) {
    var activePage = _ref.activePage;
    if (onPageChange) {
      onPageChange(activePage);
    }
  };
  return /*#__PURE__*/_jsx(Container, {
    fluid: true,
    textAlign: "center",
    children: /*#__PURE__*/_jsx(Pagination, {
      pageItem: {
        color: color
      },
      pointing: true,
      secondary: true,
      activePage: currentPage,
      totalPages: lastPage,
      onPageChange: handlePageChange
    })
  });
};
TablePagination.handledProps = ["color", "currentPage", "lastPage", "onPageChange"];
TablePagination.propTypes = {
  /** Callback page changed. */
  onPageChange: PropTypes.func,
  /** Current page. */
  currentPage: PropTypes.number,
  /** Last page. */
  lastPage: PropTypes.number,
  /** Color (domain). */
  color: PropTypes.string
};
export default TablePagination;